import Vue from 'vue'
import { BootstrapVue } from 'bootstrap-vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import LoginPage from "@/components/LoginPage";
import VotePage from "@/components/VotePage";
import UsersPage from "@/components/UsersPage";
import StatsPage from "@/components/StatsPage";
import JobPage from "@/components/JobPage";
import HistoryPage from "@/components/HistoryPage";
import EtlPage from "@/components/EtlPage";
import zoom from 'vue-image-zoom';
import VueApexCharts from 'vue-apexcharts'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-image-zoom/dist/vue-image-zoom.css';
import './app.css'
import PairsPage from "@/components/PairsPage";
import PairPage from "@/components/PairPage";


Vue.use(BootstrapVue)
Vue.use(VueRouter)
Vue.use(zoom)
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)

Vue.config.productionTip = false;


const routes = [
    {path: '/', component: LoginPage, meta: {role: null}},
    {path: '/login', component: LoginPage, meta: {role: null}},
    {path: '/vote', component: VotePage, meta: {role: "USER"}},
    {path: '/users', component: UsersPage, meta: {role: "ADMIN"}},
    {path: '/stats', component: StatsPage, meta: {role: "ADMIN"}},
    {path: '/job', component: JobPage, meta: {role: "ADMIN"}},
    {path: '/history/:offset', component: HistoryPage, meta: {role: "USER"}},
    {path: '/etl', component: EtlPage, meta: {role: "ADMIN"}},
    {path: '/pairs', component: PairsPage, meta: {role: "ADMIN"}},
    {path: '/pair/:id', component: PairPage, meta: {role: "ADMIN"}}
]

const router = new VueRouter({
    routes // short for `routes: routes`
})

new Vue({
    render: h => h(App),
    router: router
}).$mount('#app');
